import { getBaseUrl } from '../../maps/apiEnvironmentMap';

export class LoginRequestPOST {
  readonly method: string = 'auth/login';
  public buildURL() {
    let baseURL = getBaseUrl('security');
    return `${baseURL}/${this.method}`;
  }
  public generateContent(username: string, password: string) {
    const params = new URLSearchParams();
    params.append('username', username);
    params.append('password', password);
    return params;
  }
  public generateConfig() {
    return {
      headers: {},
    };
  }
}
export type LoginResponsePOST = {
  status: string;
  message: string;
  data: {
    message: string;
    errors: any;
    access_token: string;
    token_type: string;
    expires_in: number;
  };
};
